import { Input } from '@wix/design-system';
import { AsYouType } from 'libphonenumber-js/min';
import React, { useCallback, useEffect } from 'react';
import { isPhoneNumberCountry } from '../utils';
const nonDigitRegex = /[^0-9]/g;
/**
 * Phone input responsible for autoformatting depending on selected country.
 */
export const PhoneInput = _ref => {
  let {
    value,
    selectedCountry,
    onChange
  } = _ref;
  const localPhoneInputEl = React.useRef(null);
  const isBackspacePressed = React.useRef(false);
  const setLocalPhoneInputRef = useCallback(element => {
    localPhoneInputEl.current = element;
  }, []);
  const autoFormatLocalPhone = useCallback(() => {
    if (localPhoneInputEl.current) {
      const countryCodeForFormat = selectedCountry != null && selectedCountry.shortKey && isPhoneNumberCountry(selectedCountry.shortKey) ? selectedCountry.shortKey : null;
      const formattedValue = countryCodeForFormat ? new AsYouType(countryCodeForFormat).input(localPhoneInputEl.current.value) :
      // only-digits formatting when no country is set
      localPhoneInputEl.current.value.replace(nonDigitRegex, '');
      onChange(formattedValue);
    }
  }, [selectedCountry, onChange]);
  const onKeyDown = useCallback(event => {
    if (event.key === 'Backspace') {
      isBackspacePressed.current = true;
    }
  }, []);
  const onKeyUp = useCallback(event => {
    if (event.key === 'Backspace') {
      isBackspacePressed.current = false;
    }
  }, []);
  const onChangeLocal = useCallback(event => {
    if (event.target.selectionStart === event.target.value.length && !isBackspacePressed.current) {
      // Applying format-as-you-type only when we're on the end of the string and it was not a backspace
      autoFormatLocalPhone();
    } else {
      onChange(event.target.value);
    }
  }, [autoFormatLocalPhone, onChange]);
  useEffect(() => {
    autoFormatLocalPhone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);
  return /*#__PURE__*/React.createElement(Input, {
    inputRef: setLocalPhoneInputRef,
    value: value,
    size: "small",
    placeholder: "e.g., 5412345676",
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onChange: onChangeLocal,
    onBlur: autoFormatLocalPhone
  });
};
//# sourceMappingURL=PhoneInput.js.map